// @ts-check
import React, { Component } from "react"
import AvailableValidations from "../validation/AvailableValidations"
import withContext from "../withContext"

/**
 * @augments {Component<{children: (params: {errors: Broadcast_Validation[], warnings: Broadcast_Validation[]}) => any, context: BlockContext}>}
 */
class GetCurrentBlockValidation extends Component {
    /**
     *
     * @param {Broadcast_Validation[]} items
     */
    renderChildren(items) {
        const validation = items.reduce(
            (state, row) => {
                if (row.ownerBlockId === this.props.context.block.id)
                    state[row.severity + "s"].push(row)

                return state
            },
            {
                errors: [],
                warnings: [],
            }
        )

        return this.props.children(validation)
    }
    render() {
        return (
            <AvailableValidations
                children={(/** @type {Broadcast_Validation[]} */ items) =>
                    this.renderChildren(items)
                }
            />
        )
    }
}

GetCurrentBlockValidation.propTypes = {}

export default withContext(GetCurrentBlockValidation)



// WEBPACK FOOTER //
// ./src/features/editor/block/GetCurrentBlockValidation.js